import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { PageHeaderHeadingProps } from "./PageHeader.types";

export function PageHeaderHeading({
  children,
  className,
}: PageHeaderHeadingProps): JSX.Element {
  return (
    <div
      data-slot="page-header-heading"
      className={clsx(styles.heading, className)}
    >
      {children}
    </div>
  );
}
